const DEV_TOKEN = 'eyJjdHkiOiJ0ZXh0L3BsYWluIiwiYWxnIjoiZGlyIiwiZW5jIjoiQTI1NkdDTSJ9..L1ls_EqtI1IFZ_Ed.763jAh-WdZunw7BtxR5o3xmCqHoUCFx2TGEzuhofJOt4vXWBXSAchxPCP6mQ7njo1C1upkFLidLt3hlnZOFboB6IgSVAwi0zYH30AIuCH1tUxUk3BO48dVyUlUlOTAC8o-0UcdqqtzrpupeY1-2RnmEJyJwrTrKQT_sO3ormRJ9RsHAWoZBw2Aofk6PGN0WVQs3XlvdtUs-2pCKWkjVMC_O9rdvoJdxC0nER1YPZuFntg3qZ_h9L6pP-ZvvP4oO5pmhm-IxripBcmPbKRAdJ1vNOk9uc_bJ33h1cRmoDAT3V1V8gAJ2hlWz8C0VKxBg2EWeqeDRgXNE6mBhii36xEuh9PS79A_ZMqBEPSidAyfvdV6XjaDjNv7DeI6OXnP_1BLgNQU13yg.Mts8K2ULtCDY8TzzmY-_1w'
//Test user number: 7080808029
export const getAccessToken = (): string => {
  if (process.env.NODE_ENV === 'production') {
    return window.localStorage.getItem('token')
  }
  return window.localStorage.getItem('token')
  //return DEV_TOKEN
}
export const getBillFormat = (): string => window.localStorage.getItem('bill_format')

export const setBillFormat = async (format: string) => window.localStorage.setItem('bill_format', format)
export const setAccessToken = async (token: string) =>
  window.localStorage.setItem('token', token)
export const removeToken = () => window.localStorage.removeItem('token')

export const isLoggedIn = (): boolean => !!getAccessToken()

export const getSlipsCheckBoxValue = (): boolean =>
  window.localStorage.getItem('slips_checkbox') !== 'no'
export const setSlipsCheckboxValue = async (checked: boolean) =>
  window.localStorage.setItem('slips_checkbox', checked ? 'yes' : 'no')

export const getDefaultGstType = (): string =>
  window.localStorage.getItem('gst_type') ?? '0'
export const setDefaultGSTType = async (checked: string) =>
  window.localStorage.setItem('gst_type', checked)

export const getBalanceItemsCheckBoxValue = (): boolean =>
  window.localStorage.getItem('balance_items_checkbox') !== 'no'
export const setBalanceItemsCheckBoxValue = async (checked: boolean) =>
  window.localStorage.setItem('balance_items_checkbox', checked ? 'yes' : 'no')

export const getSelectedStoreId = (): string =>
  window.localStorage.getItem('selectedStore')
export const setSelectedStoreId = (selectedStoreId: string) =>
  window.localStorage.setItem('selectedStore', selectedStoreId)
export const removeSelectedStoreId = () =>
  window.localStorage.removeItem('selectedStore')

export const getUserId = (): string =>
  window.localStorage.getItem('logged_in_user_id')
export const setUserId = (userId: string) =>
  window.localStorage.setItem('logged_in_user_id', userId)
export const removeUserId = () =>
  window.localStorage.removeItem('logged_in_user_id')

export const getUserStoreId = (): string =>
  window.localStorage.getItem('user_store_id')
export const setUserStoreId = (storeId: string) =>
  window.localStorage.setItem('user_store_id', storeId)
export const removeUserStoreId = () =>
  window.localStorage.removeItem('user_store_id')

export const getNoPaymentDays = (): string => window.sessionStorage.getItem('noPaymentDays')
export const setNoPaymentDays =  (noPaymentDays: string) =>  window.sessionStorage.setItem('noPaymentDays', noPaymentDays)

export const getNoActivityDays = (): string => window.sessionStorage.getItem('noActivityDays')
export const setNoActivityDays =  (noActivityDays: string) =>  window.sessionStorage.setItem('noActivityDays', noActivityDays)

export const getMinTotalDue = (): string => window.sessionStorage.getItem('minTotalDue')
export const setMinTotalDue =  (minTotalDue: string) =>  window.sessionStorage.setItem('minTotalDue', minTotalDue)

export const getMinDuePcs = (): string => window.sessionStorage.getItem('minDuePcs')
export const setMinDuePcs =  (minDuePcs: string) =>  window.sessionStorage.setItem('minDuePcs', minDuePcs)

export const getSortBy = (): string => window.sessionStorage.getItem('sortBy')
export const setSortBy =  (sortBy: string) =>  window.sessionStorage.setItem('sortBy', sortBy)

const OTHER_CHARGES_SAC_CODE_KEY = 'other_charges_sac_code'

/** Most recently entered SAC code in Add Other Charges (not tied to charge title). */
export const getOtherChargesSacCode = (): string | null => {
  const cached =
    window.localStorage.getItem(OTHER_CHARGES_SAC_CODE_KEY)
  const trimmed = cached?.trim()
  return trimmed ? trimmed : null
}

export const setOtherChargesSacCode = (sacCode: string) => {
  const trimmed = sacCode?.trim()
  if (trimmed) {
    window.localStorage.setItem(OTHER_CHARGES_SAC_CODE_KEY, trimmed)
  }
}

export const getOtherChargesSacCodeOrDefault = (
  defaultCode = '995457'
): string => getOtherChargesSacCode() ?? defaultCode
